import { render } from "./ViewsSurveysView.vue?vue&type=template&id=d78e65aa"
import script from "./ViewsSurveysView.vue?vue&type=script&lang=js"
export * from "./ViewsSurveysView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__